// █▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
// █        JESSE STEWART         █
// █        UX/UI Designer        █
// █     www.JesseStewart.com     █
// █                              █
// █   (c) All Rights Reserved    █
// █▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█

import React from "react";
/** @jsx jsx */ import { jsx } from "@emotion/core";
import animateScrollTo from "animated-scroll-to";
import { Link } from "react-router-dom";
import {
  Typeset,
  Typepad,
  PageContainer,
  FatBottom
} from "../Partials/Typeset";
var $ = require("jquery");

export class PageTest extends React.Component {
  componentDidMount() {
    const options = {
      // duration of the scroll per 1000px, default 500
      speed: 0,
      // minimum duration of the scroll
      minDuration: 0,
      // maximum duration of the scroll
      maxDuration: 0
    };
    animateScrollTo(0, options);
    $("#Top").addClass("Banished");
  }
  render() {
    return (
      <PageContainer>
        <Typepad>
          <Typeset>
            <h1>This title needs two lines</h1>
            <p>
              A paragraph (from the Greek paragraphos, “to write beside” or
              “written beside”) is a{" "}
              <Link to="/TypeTest">self-contained unit</Link> of a discourse in
              writing dealing with sually an expected part of formal writing,
              used to organize longer prose.
            </p>
            <p>
              A paragraph (from the Greek paragraphos, “to write beside” or
              “written beside”) is a self-contained unit of a discourse in
              writing dealing with a particular point or idea. A paragraph
              consists of one or more sentences. Though not required by the
              syntax of any language, paragraphs are usually an expected part of
              formal writing, used to organize longer prose.
            </p>
            <p>
              A paragraph (from the Greek paragraphos, “to write beside” or
              “written beside”) is a self-contained unit of a discourse in
              writing dealing with a particular point or idea. A paragraph
              consists of one or more sentences. Though not required by the
              syntax of any language, paragraphs are usually an expected part of
              formal writing, used to organize longer prose.
            </p>
            <h2>This is a much longer title than you are used to.</h2>
            <p>
              A paragraph (from the Greek paragraphos, “to write beside” or
              “written beside”) is a self-contained unit of a discourse in
              writing dealing with a particular point or idea. A paragraph
              consists of one or more sentences. Though not required by the
              syntax of any language, paragraphs are usually an expected part of
              formal writing, used to organize longer prose.
            </p>
            <h3>This is a much longer title than you are used to.</h3>
            <p>
              A paragraph (from the Gblock quotation (also known as a long
              quotation or extract) is a quotation in a written documentreek
              paragraphos, “to write beside” or “written beside”) is a
              self-contained unit of a discourse in writing dealing with a
              particular point or idea. A paragraph consists of one or more
              sentences. Though not required by the syntax of any language,
              paragraphs are usually an expected part of formal writing, used to
              organize longer prose.
            </p>
            <h4>This is a much longer title than you are used to.</h4>
            <p>
              A paragraph (from the Gblock quotation (also known as a long
              quotation or extract) is a quotation in a written documentreek
              paragraphos, “to write beside” or “written beside”) is a
              self-contained unit of a discourse in writing dealing with a
              particular point or idea. A paragraph consists of one or more
              sentences. Though not required by the syntax of any language,
              paragraphs are usually an expected part of formal writing, used to
              organize longer prose.
            </p>
            <p>
              A paragraph (from the Gblock quotation (also known as a long
              quotation or extract) is a quotation in a written documentreek
              paragraphos, “to write beside” or “written beside”) is a
              self-contained unit of a discourse in writing dealing with a
              particular point or idea. A paragraph consists of one or more
              sentences. Though not required by the syntax of any language,
              paragraphs are usually an expected part of formal writing, used to
              organize longer prose.
            </p>
            <p>
              A paragraph (from the Gblock quotation (also known as a long
              quotation or extract) is a quotation in a written documentreek
              paragraphos, “to write beside” or “written beside”) is a
              self-contained unit of a discourse in writing dealing with a
              particular point or idea. A paragraph consists of one or more
              sentences. Though not required by the syntax of any language,
              paragraphs are usually an expected part of formal writing, used to
              organize longer prose.
            </p>
            <FatBottom />
          </Typeset>
        </Typepad>
      </PageContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Test.js